module["exports"] = ["(0###) #########", "(0####) #######", "+49-###-#######", "+49-####-########"];